import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 border-2 border-green-100" }
const _hoisted_2 = { class: "space-y-4" }
const _hoisted_3 = { class: "relative mb-3" }
const _hoisted_4 = { class: "max-h-48 overflow-y-auto bg-white rounded-lg border-2 border-green-100 p-2" }
const _hoisted_5 = { class: "flex flex-wrap gap-2" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex items-center gap-1.5 sm:gap-2" }
const _hoisted_8 = {
  key: 0,
  class: "w-3.5 h-3.5 sm:w-4 sm:h-4",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_9 = {
  key: 0,
  class: "text-center py-6"
}
const _hoisted_10 = { class: "text-xs text-slate-500 mt-2" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "relative mb-3" }
const _hoisted_13 = { class: "max-h-64 sm:max-h-80 overflow-y-auto bg-white rounded-lg border-2 border-green-200 p-2" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "flex items-center justify-between gap-3" }
const _hoisted_16 = { class: "flex-1 min-w-0" }
const _hoisted_17 = { class: "font-medium text-slate-800 text-xs sm:text-sm truncate" }
const _hoisted_18 = { class: "text-xs text-slate-500 truncate" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  class: "w-3 h-3 text-white",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_21 = {
  key: 0,
  class: "text-center py-6"
}
const _hoisted_22 = { class: "text-xs text-slate-500 mt-2" }
const _hoisted_23 = {
  key: 1,
  class: "bg-amber-50 border-2 border-amber-200 rounded-lg p-4"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "mt-6 pt-6 border-t-2 border-green-200" }
const _hoisted_26 = { class: "text-xs sm:text-sm font-medium text-slate-700 mb-3" }
const _hoisted_27 = {
  key: 0,
  class: "text-center py-8 sm:py-12 bg-white/60 rounded-xl border-2 border-dashed border-green-200"
}
const _hoisted_28 = {
  key: 1,
  class: "flex flex-wrap gap-2"
}
const _hoisted_29 = { class: "text-xs sm:text-sm font-medium" }
const _hoisted_30 = ["onClick"]

import { useMarcaModeloList } from "@/modules/vehiculos/composables/marcaVehiculosComposables/useMarcaModeloList";
import { useModeloVehiculoFindOne } from "@/modules/vehiculos/composables/modeloVehiculoComposables";
import { ref, computed, watch, onMounted, Ref } from "vue";

interface Props {
  modelosCompatibles: string[];
}

interface Emits {
  (e: "update:modelosCompatibles", value: string[]): void;
  (e: "agregar", modelo: string): void;
  (e: "eliminar", index: number): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ModelosCompatibles',
  props: {
    modelosCompatibles: {}
  },
  emits: ["update:modelosCompatibles", "agregar", "eliminar"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { marcas } = useMarcaModeloList();

// Estados
const busquedaMarca = ref("");
const busquedaModelo = ref("");
const marcasSeleccionadas = ref<Set<string>>(new Set());
const modelosSeleccionados = ref<Set<string>>(new Set());

// Cache para modelos buscados individualmente
const modelosCache = ref<Map<string, { nombre: string, loading: boolean }>>(new Map());

// Refs para búsquedas individuales
const modelosBuscados = ref<Map<string, Ref<string>>>(new Map());

const marcasFiltradas = computed(() => {
  if (!marcas.value) return [];

  if (!busquedaMarca.value) return marcas.value;

  const busqueda = busquedaMarca.value.toLowerCase();
  return marcas.value.filter((marca) =>
    marca.nombreMarca.toLowerCase().includes(busqueda)
  );
});

// Obtener todos los modelos de las marcas seleccionadas
const modelosDisponibles = computed(() => {
  if (!marcas.value || marcasSeleccionadas.value.size === 0) return [];

  const modelos: Array<{
    id: string;
    nombre: string;
    año: string;
    version: string;
    marcaNombre: string;
    marcaId: string;
  }> = [];

  marcasSeleccionadas.value.forEach((marcaId) => {
    const marca = marcas.value?.find((m) => m.id === marcaId);
    if (marca?.GpModeloVehiculos) {
      marca.GpModeloVehiculos.forEach((modelo) => {
        modelos.push({
          id: modelo.id,
          nombre: modelo.nombreModelo,
          año: modelo.añoModelo || "",
          version: modelo.versionModelo || "",
          marcaNombre: marca.nombreMarca,
          marcaId: marca.id,
        });
      });
    }
  });

  // Filtrar por búsqueda de modelo
  if (busquedaModelo.value) {
    const busqueda = busquedaModelo.value.toLowerCase();
    return modelos.filter(
      (m) =>
        m.nombre.toLowerCase().includes(busqueda) ||
        m.año.toLowerCase().includes(busqueda) ||
        m.version.toLowerCase().includes(busqueda)
    );
  }

  return modelos;
});

const toggleMarca = (marcaId: string) => {
  if (marcasSeleccionadas.value.has(marcaId)) {
    marcasSeleccionadas.value.delete(marcaId);
    // Limpiar modelos de esta marca
    const marca = marcas.value?.find((m) => m.id === marcaId);
    if (marca?.GpModeloVehiculos) {
      marca.GpModeloVehiculos.forEach((modelo) => {
        modelosSeleccionados.value.delete(modelo.id);
      });
    }
  } else {
    marcasSeleccionadas.value.add(marcaId);
  }
};

const toggleModelo = (modeloId: string) => {
  if (modelosSeleccionados.value.has(modeloId)) {
    modelosSeleccionados.value.delete(modeloId);
  } else {
    modelosSeleccionados.value.add(modeloId);
  }
};

const agregarSeleccionados = () => {
  const modelosAAgregar: string[] = [];

  // Si seleccionó modelos específicos
  if (modelosSeleccionados.value.size > 0) {
    modelosSeleccionados.value.forEach((modeloId) => {
      if (!props.modelosCompatibles.includes(modeloId)) {
        modelosAAgregar.push(modeloId);
      }
    });
  }

  emit("update:modelosCompatibles", [
    ...props.modelosCompatibles,
    ...modelosAAgregar,
  ]);

  modelosSeleccionados.value.clear();
  marcasSeleccionadas.value.clear();
  busquedaMarca.value = "";
  busquedaModelo.value = "";
};

const eliminarModelo = (index: number) => {
  emit("eliminar", index);
};

const totalSeleccionados = computed(() => {
  if (modelosSeleccionados.value.size > 0) {
    return modelosSeleccionados.value.size;
  }
  if (
    marcasSeleccionadas.value.size > 0 &&
    modelosDisponibles.value.length === 0
  ) {
    return marcasSeleccionadas.value.size;
  }
  return 0;
});

const hayMarcasConModelos = computed(() => {
  return (
    marcasSeleccionadas.value.size > 0 && modelosDisponibles.value.length > 0
  );
});

const hayMarcasSinModelos = computed(() => {
  return (
    marcasSeleccionadas.value.size > 0 && modelosDisponibles.value.length === 0
  );
});

// Pre-cargar nombres de modelos compatibles al montar el componente
onMounted(() => {
  props.modelosCompatibles.forEach((modeloId) => {
    obtenerNombreModelo(modeloId);
  });
});

// Observar cambios en modelosCompatibles para cargar nuevos modelos
watch(
  () => props.modelosCompatibles,
  (nuevosModelos) => {
    nuevosModelos.forEach((modeloId) => {
      obtenerNombreModelo(modeloId);
    });
  },
  { deep: true }
);

// Función para obtener nombre de modelo (con búsqueda automática)
const obtenerNombreModelo = (modeloId: string): string => {
  // 1. Buscar en las marcas cargadas en memoria
  for (const marca of marcas.value || []) {
    const modelo = marca.GpModeloVehiculos?.find((m) => m.id === modeloId);
    if (modelo) {
      return `${marca.nombreMarca} ${modelo.nombreModelo} ${
        modelo.añoModelo || ""
      } ${modelo.versionModelo || ""}`.trim();
    }
  }

  // 2. Buscar en cache
  const cached = modelosCache.value.get(modeloId);
  if (cached) {
    return cached.loading ? `Cargando...` : cached.nombre;
  }

  // 3. Si no está en cache, iniciar búsqueda individual
  buscarModeloIndividual(modeloId);

  // Retornar estado de carga mientras se busca
  return `Cargando...`;
};

// Función para buscar un modelo individual
const buscarModeloIndividual = (modeloId: string) => {
  // Evitar búsquedas duplicadas
  if (modelosCache.value.has(modeloId) || modelosBuscados.value.has(modeloId)) {
    return;
  }

  // Marcar como cargando en el cache
  modelosCache.value.set(modeloId, { nombre: '', loading: true });

  // Crear ref para el ID
  const modeloIdRef = ref(modeloId);
  modelosBuscados.value.set(modeloId, modeloIdRef);

  // Usar el composable
  const { data, isError } = useModeloVehiculoFindOne(modeloIdRef);

  // Observar cuando se cargue el modelo
  watch(
    data,
    (response) => {
      if (response && response.data) {
        const modelo = response.data;
        const nombreCompleto = `${
          modelo.data.marca?.nombreMarca || ""
        } ${modelo.data.nombreModelo} ${modelo.data.añoModelo || ""} ${
          modelo.data.versionModelo || ""
        }`.trim();

        // Actualizar cache con el nombre
        modelosCache.value.set(modeloId, { nombre: nombreCompleto, loading: false });
      }
    },
    { immediate: true }
  );

  // Manejar errores
  watch(isError, (error) => {
    if (error) {
      modelosCache.value.set(modeloId, { 
        nombre: `Error: ${modeloId.slice(0, 8)}...`, 
        loading: false 
      });
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6\"><div class=\"bg-green-600 p-2 sm:p-2.5 rounded-lg\"><svg class=\"w-5 h-5 sm:w-6 sm:h-6 text-white\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2\"></path></svg></div><h3 class=\"text-lg sm:text-xl font-bold text-slate-800\"> Modelos Compatibles </h3></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-xs sm:text-sm font-medium text-slate-700 mb-2 flex items-center gap-2" }, [
          _createElementVNode("span", { class: "bg-green-600 text-white w-6 h-6 rounded-full flex items-center justify-center text-xs" }, "1"),
          _createTextVNode(" Selecciona las marcas del vehiculo ")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((busquedaMarca).value = $event)),
            type: "text",
            placeholder: "Buscar marca...",
            class: "w-full px-4 py-2.5 text-sm border-2 rounded-lg focus:border-green-500 focus:outline-none bg-white pl-10"
          }, null, 512), [
            [_vModelText, busquedaMarca.value]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("svg", {
            class: "absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            })
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(marcasFiltradas.value, (marca) => {
              return (_openBlock(), _createElementBlock("button", {
                key: marca.id,
                onClick: ($event: any) => (toggleMarca(marca.id)),
                class: _normalizeClass(["px-3 sm:px-4 py-2 rounded-lg text-xs sm:text-sm font-medium transition-all border-2", 
                marcasSeleccionadas.value.has(marca.id)
                  ? 'bg-green-600 text-white border-green-600 shadow-md scale-105'
                  : 'bg-white text-slate-700 border-slate-200 hover:border-green-300 hover:shadow'
              ])
              }, [
                _createElementVNode("span", _hoisted_7, [
                  (marcasSeleccionadas.value.has(marca.id))
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                          "clip-rule": "evenodd"
                        }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(marca.nombreMarca), 1)
                ])
              ], 10, _hoisted_6))
            }), 128))
          ]),
          (marcasFiltradas.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("svg", {
                  class: "w-10 h-10 mx-auto text-slate-300 mb-2",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  })
                ], -1),
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "No se encontraron marcas", -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", _hoisted_10, _toDisplayString(marcasFiltradas.value.length) + " marca" + _toDisplayString(marcasFiltradas.value.length !== 1 ? "s" : "") + " " + _toDisplayString(marcasSeleccionadas.value.size > 0
              ? `• ${marcasSeleccionadas.value.size} seleccionada${
                  marcasSeleccionadas.value.size > 1 ? "s" : ""
                }`
              : ""), 1)
      ]),
      (hayMarcasConModelos.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-xs sm:text-sm font-medium text-slate-700 mb-2 flex items-center gap-2" }, [
              _createElementVNode("span", { class: "bg-green-600 text-white w-6 h-6 rounded-full flex items-center justify-center text-xs" }, "2"),
              _createTextVNode(" Selecciona los modelos ")
            ], -1)),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((busquedaModelo).value = $event)),
                type: "text",
                placeholder: "Buscar modelo, año o versión...",
                class: "w-full px-4 py-2.5 text-sm border-2 rounded-lg focus:border-green-500 focus:outline-none bg-white pl-10"
              }, null, 512), [
                [_vModelText, busquedaModelo.value]
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("svg", {
                class: "absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                })
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelosDisponibles.value, (modelo) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: modelo.id,
                  onClick: ($event: any) => (toggleModelo(modelo.id)),
                  class: _normalizeClass(["w-full text-left px-3 py-2.5 rounded-lg mb-1 transition-all border-2", 
              modelosSeleccionados.value.has(modelo.id)
                ? 'bg-green-100 border-green-400'
                : 'bg-white border-transparent hover:bg-slate-50 hover:border-slate-200'
            ])
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("p", _hoisted_17, _toDisplayString(modelo.marcaNombre) + " " + _toDisplayString(modelo.nombre), 1),
                      _createElementVNode("p", _hoisted_18, [
                        _createTextVNode(_toDisplayString(modelo.año || "Sin año") + " ", 1),
                        (modelo.version)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, " • " + _toDisplayString(modelo.version), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["w-5 h-5 rounded border-2 flex items-center justify-center transition-all flex-shrink-0", 
                  modelosSeleccionados.value.has(modelo.id)
                    ? 'bg-green-600 border-green-600'
                    : 'border-slate-300'
                ])
                    }, [
                      (modelosSeleccionados.value.has(modelo.id))
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_20, [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                              "clip-rule": "evenodd"
                            }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ], 2)
                  ])
                ], 10, _hoisted_14))
              }), 128)),
              (modelosDisponibles.value.length === 0 && busquedaModelo.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("svg", {
                      class: "w-10 h-10 mx-auto text-slate-300 mb-2",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      })
                    ], -1),
                    _createElementVNode("p", { class: "text-sm text-slate-500" }, "No se encontraron modelos", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", _hoisted_22, _toDisplayString(modelosDisponibles.value.length) + " modelo" + _toDisplayString(modelosDisponibles.value.length !== 1 ? "s" : "") + " disponible" + _toDisplayString(modelosDisponibles.value.length !== 1 ? "s" : "") + " " + _toDisplayString(modelosSeleccionados.value.size > 0
              ? `• ${modelosSeleccionados.value.size} seleccionado${
                  modelosSeleccionados.value.size > 1 ? "s" : ""
                }`
              : ""), 1)
          ]))
        : _createCommentVNode("", true),
      (hayMarcasSinModelos.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[10] || (_cache[10] = [
            _createStaticVNode("<div class=\"flex gap-3\"><svg class=\"w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg><div><p class=\"text-sm font-medium text-amber-900\"> No hay modelos específicos </p><p class=\"text-xs text-amber-700 mt-1\"> Al agregar, se incluirán todas las marcas seleccionadas como compatibles con todos sus modelos. </p></div></div>", 1)
          ]))]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: agregarSeleccionados,
        disabled: totalSeleccionados.value === 0,
        class: "w-full px-6 py-3 bg-green-600 text-white rounded-xl font-medium hover:bg-green-700 transition-all disabled:bg-slate-300 disabled:cursor-not-allowed flex items-center justify-center gap-2 text-sm sm:text-base"
      }, [
        _cache[11] || (_cache[11] = _createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
          })
        ], -1)),
        _createTextVNode(" Agregar seleccionados (" + _toDisplayString(totalSeleccionados.value) + ") ", 1)
      ], 8, _hoisted_24)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("p", _hoisted_26, " Modelos agregados (" + _toDisplayString(__props.modelosCompatibles.length) + ") ", 1),
      (__props.modelosCompatibles.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("svg", {
              class: "w-12 h-12 sm:w-16 sm:h-16 mx-auto text-green-300 mb-3",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
              })
            ], -1),
            _createElementVNode("p", { class: "text-slate-600 text-sm sm:text-base font-medium" }, " No hay modelos agregados ", -1),
            _createElementVNode("p", { class: "text-slate-400 text-xs sm:text-sm mt-1" }, " Selecciona marcas y modelos arriba ", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelosCompatibles, (modelo, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "group flex items-center gap-2 bg-white border-2 border-green-200 text-green-700 px-3 py-1.5 sm:py-2 rounded-lg hover:border-green-400 hover:shadow-md transition-all"
              }, [
                _cache[14] || (_cache[14] = _createElementVNode("svg", {
                  class: "w-3.5 h-3.5 sm:w-4 sm:h-4 text-green-600",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M5 13l4 4L19 7"
                  })
                ], -1)),
                _createElementVNode("span", _hoisted_29, _toDisplayString(obtenerNombreModelo(modelo)), 1),
                _createElementVNode("button", {
                  onClick: ($event: any) => (eliminarModelo(index)),
                  class: "ml-1 hover:bg-red-100 rounded-full p-1 transition-colors"
                }, [...(_cache[13] || (_cache[13] = [
                  _createElementVNode("svg", {
                    class: "w-3.5 h-3.5 sm:w-4 sm:h-4 text-red-600",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))], 8, _hoisted_30)
              ]))
            }), 128))
          ]))
    ])
  ]))
}
}

})